// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NestedAccordPart_wrapper__1vRav","netWrapper":"NestedAccordPart_netWrapper__S5QFy"};